import { render, staticRenderFns } from "./TestPackageGroupSort.vue?vue&type=template&id=669ce49e"
import script from "./TestPackageGroupSort.vue?vue&type=script&lang=js"
export * from "./TestPackageGroupSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports